import { getSettings } from '@/services/settings';

export const state = {
  courseConnectionActivated: false,
};

export const mutations = {
  applySettings(state, settings) {
    if (settings.FEATURE_GORBA_REPLACEMENT) {
      state.courseConnectionActivated = settings.FEATURE_GORBA_REPLACEMENT;
    }
  },
};

export const actions = {
  getAndApplySettings({ commit }) {
    return getSettings().then(response => {
      commit('applySettings', response.data);
    });
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
